<div class="error-message" *ngIf="ningunEstablecimientoSeleccionado">Selecciona algún establecimiento</div>
<div class="error-message" *ngIf="errorCamposIncorrectos && !ningunEstablecimientoSeleccionado">Hay campos introducidos incorrectamente</div>
<div class="ok-message fade-out" *ngIf="!errorCamposIncorrectos && alarmasCreadas !errorFinal">Las alarmas se han establecido correctamente</div>
<div class="error-message fade-out" *ngIf="errorFinal">{{errorMessage}}</div>

<div class="container">

    <div class="header">
        <div class="header-content">
            <span class="font20">ESTABLECER ALARMAS</span>
            <button mat-icon-button matTooltip="Registrar nuevo establecimiento" class="gurdar-btn" (click)="guardarDispositivo()" [disabled]="waitAfterSave">
                <mat-icon>save</mat-icon>
            </button>
        </div>
        <span class="header-text font14">Formulario DataBeer para agregar alarmas a los establecimientos</span>
    </div>

    <div class="body">
        
        <div class="establecimientos-container">
            <span class="titulo-negrita" [ngClass]="{'error-select': ningunEstablecimientoSeleccionado}">ESTABLECIMIENTOS *<mat-icon class="custom2">store</mat-icon></span>
            <mat-form-field class="marginTop15">
                <mat-label>-Establecimientos-</mat-label>
                <mat-select [(ngModel)]="selectedEstablecimiento" name="modVer" multiple>
                  <mat-checkbox [(ngModel)]="selectAllEstablecimientos" (change)="selectAllEstablecimientosChanged()" 
                  color="primary" class="marginLeft5">
                    <span class="custom">Seleccionar todos</span>
                  </mat-checkbox>
                  <mat-option *ngFor="let modVer of establecimientosCopia" [value]="modVer.value">
                    {{modVer.name}}
                  </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-error *ngIf="ningunEstablecimientoSeleccionado" class="custom1">
                Selecciona algún establecimiento
            </mat-error>
        </div>
        
        <span class="titulo-negrita">Nivel mínimo de cerveza: </span>
        <form [formGroup]="configuracionAlarmas">
            <mat-form-field class="etiqueta-container">
                <mat-label class="etiqueta-label">Nivel (%)</mat-label>
                <input matInput type="text" formControlName="nivelCerveza">
            </mat-form-field>
            <mat-error *ngIf="configuracionAlarmas.get('nivelCerveza')?.hasError('pattern')" class="custom3">
                Ingresa solo <strong>números</strong>
            </mat-error>
            <mat-error *ngIf="configuracionAlarmas.get('nivelCerveza')?.hasError('min')" class="error-custom">
                El valor debe ser mayor o igual a <strong>0</strong>
            </mat-error>
            <mat-error *ngIf="configuracionAlarmas.get('nivelCerveza')?.hasError('max')" class="error-custom">
                El valor debe ser menor o igual a <strong>100</strong>
            </mat-error>
        </form>

        <div class="marginTop15">
            <span class="titulo-negrita">Temperatura: </span>
            <div class="temp-container">
                <form [formGroup]="configuracionAlarmas" class="temp-minima">
                    <mat-form-field class="etiqueta-container marginTop20">
                        <mat-label class="etiqueta-label">Mínimo (ºC)</mat-label>
                        <input matInput type="text" formControlName="temperaturaTanqueMin">
                    </mat-form-field>
                    <mat-error *ngIf="configuracionAlarmas.get('temperaturaTanqueMin')?.hasError('pattern')" class="error-custom">
                        Ingresa solo <strong>números</strong>
                    </mat-error>
                </form>
    
                <form [formGroup]="configuracionAlarmas" class="temp-maxima">
                    <mat-form-field class="etiqueta-container marginTop20">
                        <mat-label class="etiqueta-label">Máximo (ºC)</mat-label>
                        <input matInput type="text" formControlName="temperaturaTanqueMax">
                    </mat-form-field>
                    <mat-error *ngIf="configuracionAlarmas.get('temperaturaTanqueMax')?.hasError('pattern')" class="error-custom">
                        Ingresa solo <strong>números</strong>
                    </mat-error>
                </form>
            </div>
        </div>

        <div class="marginTop15">
            <span class="titulo-negrita">Presión: </span>
            <div class="temp-container">
                <form [formGroup]="configuracionAlarmas" class="temp-minima">
                    <mat-form-field class="etiqueta-container marginTop20">
                        <mat-label class="etiqueta-label">Mínimo (Bar)</mat-label>
                        <input matInput type="text" formControlName="presionMin">
                    </mat-form-field>
                    <mat-error *ngIf="configuracionAlarmas.get('presionMin')?.hasError('pattern')" class="error-custom">
                        Ingresa solo <strong>números</strong>
                    </mat-error>
                </form>
    
                <form [formGroup]="configuracionAlarmas" class="temp-maxima">
                    <mat-form-field class="etiqueta-container marginTop20">
                        <mat-label class="etiqueta-label">Máximo (Bar)</mat-label>
                        <input matInput type="text" formControlName="presionMax">
                    </mat-form-field>
                    <mat-error *ngIf="configuracionAlarmas.get('presionMax')?.hasError('pattern')" class="error-custom">
                        Ingresa solo <strong>números</strong>
                    </mat-error>
                </form>
            </div>
        </div>
    </div>
</div>
<div class="footer"></div>

